<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="formData" :inline="true" size="mini" label-width="60px">
          <el-form-item label="品类">
            <el-select v-model="formData.category" filterable>
              <el-option label="全部" value=""></el-option>
              <el-option :label="item" :value="item" v-for="(item, index) in categoryOptions" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维度">
            <el-select v-model="formData.tag">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.label" :value="item.value" v-for="(item, index) in tagOptions" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="onReset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="mini" @click="addDesc">新增描述</el-button>
        <el-button type="warning" size="mini" @click="deleteSelection">删除描述</el-button>
        <el-button type="primary" size="mini" @click="addCategory">新增品类</el-button>
      </template>
      <el-table
        stripe
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :data="tableData"
        :height="maxTableHeight"
        @selection-change="onSelectChange"
        v-loading="loading"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column label="品类" prop="category" show-overflow-tooltip></el-table-column>
        <el-table-column label="维度" prop="tagName" show-overflow-tooltip></el-table-column>
        <el-table-column label="描述" prop="optionDesc" show-overflow-tooltip></el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <add-desc v-model="addDescVisible" v-if="addDescVisible" @complete="init"></add-desc>
    <add-category v-model="addCategoryVisible" v-if="addCategoryVisible" @complete="getOptions"></add-category>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import delMixin from "./del.mixin";
import addDesc from "./addDesc";
import addCategory from "./addCategory";
import tableMixin from '@/utils/tableMixin';
export default {
  mixins: [delMixin, pagePathMixin, tableMixin],
  components: {
    addDesc,
    addCategory,
  },
  data() {
    return {
      loading: false,
      formData: {
        category: "",
        tag: "",
      },
      tableData: [],
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      addDescVisible: false,
      addCategoryVisible: false,
      categoryOptions: [],
      tagOptions: [],
    };
  },
  mounted() {
    this.init();
    this.getOptions();
  },
  methods: {
    onSearch() {
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    onReset() {
      this.formData = {
        category: "",
        tag: "",
      };
      this.$nextTick(() => {
        this.onSearch();
      });
    },
    init() {
      this.loading = true;
      let data = {
        pageSize: this.paginationOpt.pageSize,
        pageNum: this.paginationOpt.pageNum,
        filterData: {
          ...this.formData,
        },
      };
      this.$q.product
        .getCategoryConfig({ data: data })
        .then((res) => {
          this.tableData = res.data.records;
          this.paginationOpt["total"] = res.data.total;
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    addDesc() {
      this.addDescVisible = true;
    },
    addCategory() {
      this.addCategoryVisible = true;
    },
    getOptions() {
      this.$q.product.getCategoryTag()
      .then(res => {
        const { category, tag } = res.data;
        this.categoryOptions = category;
        this.tagOptions = Object.keys(tag).map(k => {
          return {
            label: tag[k],
            value: k
          }
        });
      })
    }
  },
};
</script>
<style lang="stylus" scoped>
.footerBox
  text-align right
.search-box
  >>> .el-select, >>> .el-input
    width 200px !important
</style>
